'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['actionbegin', 'actionbreak', 'actionend', 'actiontick', 'actiontickcomplete', 'balloonclose', 'balloonopen', 'boundschange', 'click', 'contextmenu', 'dblclick', 'destroy', 'hintclose', 'hintopen', 'marginchange', 'mousedown', 'mouseenter', 'mouseleave', 'mousemove', 'mouseup', 'multitouchend', 'multitouchmove', 'multitouchstart', 'optionschange', 'sizechange', 'typechange', 'wheel'];


//////////////////
// WEBPACK FOOTER
// ./~/yandex-map-react/lib/apiEventsLists/map.js
// module id = 486
// module chunks = 0